import { Injectable } from '@angular/core'
import { Router, CanActivate } from '@angular/router'
import { TokenName } from '../store'

@Injectable()

export class AdminGuard implements CanActivate {

  constructor(private router: Router) {}

  public canActivate() {
    const item = JSON.parse(localStorage.getItem(TokenName))
    if (item && item.role) {
      return true
    } else {
      this.router.navigate(['/'])
      return false
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/guards/admin.guard.ts